import { createFileRoute } from "@tanstack/react-router";
import { RuleBuilderPage } from "@/features/automation/rule-builder";
import { apiQuery } from "@/lib/api/hooks";

/** `/automation/rules/new` creates; any other id edits. */
export const Route = createFileRoute("/_app/automation/rules/$ruleId")({
  loader: ({ context, params }) => (params.ruleId === "new" ? undefined : context.queryClient.ensureQueryData(apiQuery("rules", {})).catch(() => undefined)),
  head: () => ({ meta: [{ title: "Rule builder · Malfak" }] }),
  component: RuleRoute,
});

function RuleRoute() {
  const { ruleId } = Route.useParams();
  return <RuleBuilderPage ruleId={ruleId} />;
}
